module.exports = __webpack_public_path__ + "img/92cbbfd8197db544f3057b1d5c8bee9e.jpg";